import { IJsonQuery } from './types/jsonQuery';
import { TJsonQueryKey } from './types';
import { PROPERTIES } from './properties';

export function convertProperties(jsonQuery: IJsonQuery): IJsonQuery {
  const keys = Object.keys(jsonQuery) as TJsonQueryKey[];

  return keys.reduce((nextJsonQuery, currentKey) => {
    if (!!nextJsonQuery[currentKey] && PROPERTIES[currentKey]) {
      const { converter } = PROPERTIES[currentKey];
      if (converter) {
        return converter(nextJsonQuery);
      }
    }

    return nextJsonQuery;
  }, jsonQuery);
}
